//import { storeSet } from '../store';

const set404FromErrorResponse = (data) => {
    if (data && data.status === 'NOT_FOUND') {
        //storeSet('isError404', true);
    }
}

export default set404FromErrorResponse;